// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const MessagesInboxClient = registerClientReference(
    function() { throw new Error("Attempted to call MessagesInboxClient() from the server but MessagesInboxClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(seller)/seller/inbox/messages/messages-inbox-client.tsx",
    "MessagesInboxClient",
);
